import type { ReactNode } from "react";

import { AppHeaderRail } from "@/components/common/AppHeaderRail";
import { InspectorRailToggle } from "@/components/workspace/InspectorRailToggle";
import { useWorkspaceShell } from "@/components/workspace/WorkspaceShell";

/**
 * The thin conversation top bar: title on the left, optional actions and the
 * inspector-toggle on the right. Deliberately minimal — no status chips.
 */
export function WorkspaceTopBar({ title, actions }: { title: string; actions?: ReactNode }) {
  const { inspectorEnabled } = useWorkspaceShell();

  return (
    <AppHeaderRail
      compact
      title={<h1 className="truncate text-sm font-semibold">{title}</h1>}
      actions={
        <>
          {actions}
          {inspectorEnabled ? <InspectorRailToggle /> : null}
        </>
      }
    />
  );
}
